export default function StaffSection() {
  const staff = [
    {
      name: '岡山 太郎',
      position: '代表取締役',
      experience: '土木工事歴25年',
      description: '岡山県の土木工事業界で25年の経験を持つ。安全第一をモットーに、お客様に満足いただける工事を心がけています。',
      image: 'https://public.readdy.ai/ai/img_res/67eaf363c7e79bb98a4d76d22746047d.jpg',
      qualifications: ['1級土木施工管理技士', '建設業許可（土木工事業）']
    },
    {
      name: '倉敷 次郎',
      position: '工事部長',
      experience: '土木工事歴20年',
      description: '現場管理のスペシャリスト。品質管理と安全管理を徹底し、確実な工事進行を実現します。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20male%20construction%20site%20manager%20in%20his%2040s%20wearing%20safety%20helmet%20and%20work%20uniform%2C%20experienced%20and%20reliable%20appearance%20with%20confident%20smile%2C%20outdoor%20construction%20site%20background%20with%20clear%20sky%2C%20natural%20daylight%20photography%2C%20realistic%20portrait%20style%2C%20high%20quality%20professional%20photography&width=300&height=400&seq=staff2jp&orientation=portrait',
      qualifications: ['1級土木施工管理技士', '安全管理者']
    },
    {
      name: '岡山 花子',
      position: '事務・営業担当',
      experience: '建設業界歴15年',
      description: 'お客様との窓口として、丁寧な対応を心がけています。工事に関するご相談は何でもお気軽にお声かけください。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20female%20office%20manager%20in%20her%2030s%2C%20wearing%20business%20attire%2C%20friendly%20and%20professional%20appearance%2C%20office%20environment%20background%2C%20natural%20lighting%2C%20professional%20portrait%20style%2C%20high%20quality%20business%20photography&width=300&height=400&seq=staff3&orientation=portrait',
      qualifications: ['建設業経理士2級', '宅地建物取引士']
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <strong>スタッフ紹介</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            経験豊富なプロフェッショナルが、お客様の大切な工事を責任を持って担当いたします。
            安全・確実・丁寧な施工でご満足いただけるよう努めています。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {staff.map((member, index) => (
            <div key={index} className="bg-gray-50 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <div className="h-80 overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{member.name}</h3>
                <div className="text-blue-600 font-semibold mb-1">{member.position}</div>
                <div className="text-sm text-gray-500 mb-4">{member.experience}</div>
                <p className="text-gray-600 mb-4 leading-relaxed">{member.description}</p>
                <div className="space-y-1">
                  <div className="text-sm font-semibold text-gray-700">保有資格：</div>
                  {member.qualifications.map((qual, idx) => (
                    <div key={idx} className="text-sm text-gray-600">・{qual}</div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}